// Global fix for quick-add modals in cart drawer
// Runs immediately to move modals before any interaction
(function () {
  "use strict";

  const processed = new WeakSet();

  function moveModal(modal) {
    if (processed.has(modal) || modal.parentElement === document.body) return;
    processed.add(modal);
    document.body.appendChild(modal);
  }

  function scanAll() {
    document.querySelectorAll("quick-add-modal").forEach(moveModal);
  }

  // Intercept custom element registration
  if (window.customElements && !window.customElements.get("quick-add-modal")) {
    const origDefine = window.customElements.define.bind(window.customElements);
    window.customElements.define = function (name, constructor, options) {
      if (name === "quick-add-modal") {
        const Orig = constructor;
        constructor = class extends Orig {
          connectedCallback() {
            if (super.connectedCallback) super.connectedCallback();
            if (this.parentElement !== document.body) {
              document.body.appendChild(this);
            }
          }
        };
      }
      return origDefine(name, constructor, options);
    };
  }

  // Watch for open attribute changes
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.target.tagName === "QUICK-ADD-MODAL") {
        moveModal(m.target);
      }
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["open"],
    subtree: true,
  });

  // Scan immediately and repeatedly
  scanAll();
  for (const delay of [0, 10, 50, 100, 200, 500, 1000, 2000]) {
    setTimeout(scanAll, delay);
  }

  window.forceModalScan = scanAll;
})();
